import React from 'react';
import FavouriteManager from '../../services/favourite-manager';

export default class ShortlistClear extends React.Component {
    constructor (props){
        super(props);
        this.favouriteManager = new FavouriteManager;
    }

    onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.favouriteManager.clearFromStorage();
    };

    render () {
        return( <span className={this.props.className} onClick={this.onClick}>{this.props.text}</span> );
    }
}